<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">活動管理</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <div v-show="!grid.isEditing && grid.isRowSelected" id="batch-dropdown" class="dropdown ml-auto mr-2 sm:ml-0">
          <button class="dropdown-toggle button px-2 box bg-blue-500 text-white flex items-center">
            <FontAwesome icon="tasks" type="fas" class="w-4 h-4 mr-1" />
            群組操作
          </button>
          <div class="dropdown-box">
            <div class="dropdown-box__content box dark:bg-dark-1 p-2 w-32">
              <!-- <span
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                @click="grid.removeSelectedRows"
              >
                <FontAwesome icon="trash" type="fas" class="w-4 h-4 mr-2" /> 刪除
              </span> -->
              <span
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                @click="grid.onPrint({ mode: 'selected' })"
              >
                <FontAwesome icon="print" type="fas" class="w-4 h-4 mr-2" /> 列印
              </span>
              <span
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                @click="grid.onExport({ type: 'csv', mode: 'selected' })"
              >
                <FontAwesome icon="file-csv" type="fas" class="w-4 h-4 mr-2" /> 匯出 CSV
              </span>
              <span
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                @click="grid.onExport({ type: 'html', mode: 'selected' })"
              >
                <FontAwesome icon="file" type="fas" class="w-4 h-4 mr-2" /> 匯出 HTML
              </span>
            </div>
          </div>
        </div>
        <button v-show="!grid.isEditing" class="button text-white bg-theme-1 shadow-md mr-2 flex items-center" @click="grid.addNewRow">
          <FontAwesome icon="plus" type="fas" class="w-4 h-4 mr-1" />
          新增
        </button>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <div class="xl:flex sm:mr-auto">
          <div class="sm:flex items-center ml-1 sm:mr-2 mt-2 xl:mt-0">
            <input type="search" class="input w-full sm:w-40 xxl:w-full mt-2 sm:mt-0 border" v-model.trim="grid.keyword" placeholder="請輸入關鍵字" />
          </div>
          <div class="mt-2 xl:mt-0">
            <button type="button" class="button w-full sm:w-16 bg-theme-1 text-white" @click="grid.refresh">
              搜尋
            </button>
          </div>
        </div>
        <!-- <div class="flex mt-2 sm:mt-0">
          <button class="button w-1/2 sm:w-auto flex items-center border text-gray-700 dark:bg-dark-5 dark:text-gray-300" @click="grid.onPrint({ mode: 'curret' })">
            <FontAwesome icon="print" class="w-4 h-4 mr-2" /> 列印
          </button>
          <div class="dropdown w-1/2 sm:w-auto ml-2">
            <button class="dropdown-toggle button w-full sm:w-auto flex items-center border text-gray-700 dark:bg-dark-5 dark:text-gray-300">
              <FontAwesome icon="file-export" class="w-4 h-4 mr-2" /> 匯出
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-box">
              <div class="dropdown-box__content box dark:bg-dark-1 p-2">
                <a
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="grid.onExport({ type: 'csv' })"
                >
                  <FontAwesome icon="file-csv" class="w-4 h-4 mr-2" /> CSV
                </a>
                <a
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="grid.onExport({ type: 'html' })"
                >
                  <FontAwesome icon="file" type="fas" class="w-4 h-4 mr-2" /> HTML
                </a>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="overflow-x-auto scrollbar-hidden mt-2">
        <grid
          ref="grid"
          v-bind="gridOptions"
          @addNewRow="(row, callback) => { row.Published = false; row.ViewCount = 0; row.IsFree = false; row.IsFull = false; row.RequireQnr = false; row.Type = 0; row.Description = {Content: ''}; row.Additional = {Content: ''}; row.Contact = ''; callback(); }"
          @edit="onGridEdit"
          @removeSelectedRows="hideBatchDropDown()"
          @modalResize="onGridModalResize"
        >
          <template #session="{ row }">
            <vxe-button type="button" content="查看" @click="sessionModal.show(row)"></vxe-button>
          </template>
          <template #attend="{ row }">
            <vxe-button type="button" content="查看" @click="attendModal.show(row)"></vxe-button>
          </template>
          <!-- <template #survey="{ row }">
            <vxe-button type="button" content="查看" @click="surveyModal.show(row)"></vxe-button>
          </template> -->
          <template #modal="{ row, submit, reset }">
            <vxe-form
              ref="form"
              v-bind="formOptions"
              :data="row"
              @reset="reset"
              @submit="() => { row.ActivityUnits = $refs.unitTable.getData(); submit() }"
            >
              <!-- <template #column-qnr="{ data }">
                <select-box v-bind="selectorOptions" v-model="data.QnrId" />
              </template> -->
              <template #column-epaper="{ data }">
                <select-box v-bind="epaperSelectorOptions" v-model="data.EpaperId" />
              </template>
              <template #column-keyword="{ data }">
                <select-box v-bind="selectorOptions" v-model="data.QnrId" />
              </template>
              <template #column-report-user-id="{ data }">
                <select-box v-bind="userSelectorOptions" v-model="data.OwnerId" />
              </template>
              <template #column-unit="{ data }">
                <UnitTable ref="unitTable" :aid="data.Id" @refresh="refresh" :data="data.ActivityUnits" />
              </template>
              <template #html-editer="{ data }">
                <!-- <div class="mb-4">
                  <p class="mb-2">報名窗口</p>
                  <CKEditor
                    v-model="data.Contact"
                    @update:modelValue="value => (data.Contact = value)"
                    :editor="classicEditor"
                    :config="contactConfig"
                  />
                </div> -->
                <div class="mb-4" v-if="data.Description">
                  <p class="mb-2">活動說明</p>
                  <CKEditor
                    v-model="data.Description.Content"
                    @update:modelValue="value => (data.Description.Content = value)"
                    :editor="classicEditor"
                    :config="editorConfig"
                  />
                </div>
              </template>
              <template #column-photo-and-remark="{ data }">
                <div class="flex justify-center">
                  <file-uploader
                    :ref="el => uploader = el"
                    id="user-photo-uri"
                    style="min-width: 250px; max-width: 250px; min-height: 184px; max-height: 184px;"
                    class="mb-10"
                    mode="image"
                    :headers="{ Authorization: `Basic ${model?.getCertificate(0)}` }"
                    :modelValue="data.Photo?.Uri"
                    :action="uploadAction"
                    :autoUpload="true"
                    :limitedWidth="560"
                    :limitedHeight="360"
                    @update:modelValue="(value) => { if (data.Photo) data.Photo.Uri = value; else data.Photo = { Uri: value }; }"
                    @filter="uploaderFilter"
                  />
                </div>
              </template>
              <template #column-banner-and-remark="{ data }">
                <div class="flex justify-center">
                  <file-uploader
                    :ref="el => uploader = el"
                    id="user-banner-uri"
                    style="min-width: 350px; max-width: 350px; min-height: 184px; max-height: 184px;"
                    class="mb-10"
                    mode="image"
                    :headers="{ Authorization: `Basic ${model?.getCertificate(0)}` }"
                    :modelValue="data.Banner?.Uri"
                    :action="uploadAction"
                    :autoUpload="true"
                    :limitedWidth="1200"
                    :limitedHeight="550"
                    @update:modelValue="(value) => { if (data.Banner) data.Banner.Uri = value; else data.Banner = { Uri: value }; }"
                    @filter="uploaderFilter"
                  />
                </div>
              </template>
              <template #files>
                <FileUploadTable
                  ref="fileGrid"
                  v-if="row.Id"
                  :title="'活動簡報'"
                  v-bind="fileModal.uploadOptions"
                  :canUpload="true"
                  :canDelete="true"/>
              </template>
            </vxe-form>
          </template>
          <template #modal-footer>
            <vxe-button type="submit" status="primary" content="確認" @click="$refs.form.validate((errMap) => { if (errMap === undefined) $refs.form.dispatchEvent('submit'); })"></vxe-button>
            <vxe-button type="reset" content="重置" @click="$refs.form.dispatchEvent('reset')"></vxe-button>
          </template>
          <template #filter-name="{ column, $panel }">
            <div v-for="(option, index) in column.filters" :key="index" class="flex item-center justify-center">
              <input type="checkbox"
                class="input input--switch border mt-4 ml-2"
                :checked="option.checked"
                @input="grid.changeFilterEvent(event, option, $panel, true)"
              />
              <div class="relative m-2">
                <div class="absolute rounded-l-md w-10 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600">
                  {{option.label}}
                </div>
                <input
                  v-model.trim="option.data"
                  :disabled="!option.checked"
                  type="text"
                  class="input pl-12 w-full border col-span-4"
                  placeholder="請輸入文字"
                  @input="grid.changeFilterEvent(event, option, $panel)"
                />
              </div>
            </div>
          </template>
        </grid>
      </div>
    </div>
    <!-- END: HTML Table Data -->
    <vxe-modal v-model="sessionModal.visible" width="80%" title="活動場次" show-zoom="true">
      <SessionTable ref="sessionGrid" v-bind="sessionModal.gridOptions" :modelValue="sessionModal.visible" :sid="sessionModal.selectedRow.Id" />
    </vxe-modal>
    <vxe-modal resize v-model="attendModal.visible" width="80%" title="報名資料" height="700" show-zoom="true">
      <AttendTable ref="attendGrid" v-bind="attendModal.gridOptions" :modelValue="attendModal.visible" :sid="attendModal.selectedRow.Id" />
    </vxe-modal>
    <!-- <vxe-modal resize v-model="surveyModal.visible" width="80%" title="媒合洽談意願調查表" height="700" show-zoom="true">
      <SurveyTable ref="surveyGrid" v-bind="surveyModal.gridOptions" @close="surveyModal.close" :modelValue="surveyModal.visible" :sid="surveyModal.selectedRow.Id" />
    </vxe-modal> -->
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import CloudFun, { Condition, defineComponent, Operator, ref, onMounted, reactive } from '@cloudfun/core'
import Grid, { GridOptions } from '@/cloudfun/components/Grid.vue'
import { VxeFormProps } from 'vxe-table'
import SelectBox, { SelectBoxOptions } from '@/cloudfun/components/SelectBox.vue'
import formatDate from 'xe-utils/toDateString';
import FileUploader from "@/cloudfun/components/FileUploader.vue";
import { VueUploadItem } from "vue-upload-component";
import ClassicEditor from "@/global-components/ckeditor/classic-editor";
import UploadAdapterPlugin from "@/global-components/ckeditor/upload-adapter-plugin";
import SessionTable from "@/components/activity/SessionTable.vue";
import AttendTable from "@/components/activity/AttendTable.vue";
// import SurveyTable from "@/components/activity/SurveyTable.vue";
import UnitTable from "@/components/activity/UnitTable.vue";
import "@/global-components/ckeditor/styles.css";

export default defineComponent({
  components: {
    Grid,
    FileUploader,
    SelectBox,
    SessionTable,
    AttendTable,
    UnitTable,
    // SurveyTable,
  },
  setup () {
    const model = CloudFun.current?.model;
    const users = ref<{ label: string; value: string }[]>([]);
    const grid = ref<any>({})
    var printColumns = [
      { field: 'Name' },
      { field: 'Description' }
    ]
    const uploader = ref<any>({});

    const gridOptions: GridOptions = {
      stripe: false,
      title: '活動管理',
      toolbarConfig: {
        custom: true,
        refresh: true
      },
      multiselect: false,
      printConfig: { sheetName: '活動管理清單', columns: printColumns, modes: ['current', 'selected', 'all'] },
      exportConfig: { filename: '活動管理清單', type: 'csv', types: ['html', 'csv'], mode: 'all', modes: ['current', 'selected', 'all'], columns: printColumns },
      columns: [
      // { field: 'Number', title: '編號', showHeaderOverflow: true, showOverflow: true, sortable: true },
      {
        field: 'Name',
        title: '名稱',
        width: '25%',
        showHeaderOverflow: true,
        showOverflow: true,
        sortable: true,
        treeNode: false,
        editRender: { name: '$input', immediate: true, attrs: { type: 'text' } },
        filters: [{ checked: false, label: '包含' }],
        slots: { filter: 'filter-name' }
      },
      { field: "Type", title: "類型", width: '8%', showHeaderOverflow: true, showOverflow: true, sortable: true, formatter: ({ cellValue }) => model ? Object.values(model.enums.ActivityType).find(e => e.Value === cellValue)?.Name : undefined },
      { field: 'Place', title: '地點', width: '15%', showHeaderOverflow: true, showOverflow: true, sortable: true },
      {
        field: 'StartTime',
        title: '活動日期',
        showHeaderOverflow: true,
        showOverflow: true,
        sortable: true,
        formatter: ({ cellValue }) => formatDate(new Date(cellValue), 'yyyy/MM/dd')
      },
      { field: 'Published', title: '已發布', showHeaderOverflow: true, showOverflow: true, formatter: ({ cellValue }) => cellValue ? '是' : '否', align: 'center' },
      { field: 'IsFree', title: '是否免費', showHeaderOverflow: true, showOverflow: true, formatter: ({ cellValue }) => cellValue ? '是' : '否', align: 'center' },
      {
        title: '活動場次',
        width: '100',
        slots: { default: "session" }, align: 'center'
      },
      {
        title: '報名資料',
        width: '100',
        slots: { default: "attend" }, align: 'center'
      }
      // {
      //   title: '媒合調查表',
      //   width: '100',
      //   slots: { default: "survey" }, align: 'center'
      // }
      ],
      promises: {
        query: model ? (params) => {
          if (params?.sortings?.length === 0) {
            params.sortings.push({ column: 'CreatedTime', order: 1 });
          }
          // if (params.condition) params.condition.and('ParentId', Operator.IsNull)
          // else params.condition = new Condition('ParentId', Operator.IsNull)
          return model.dispatch('activity/query', params)
        } : undefined,
        queryAll: model ? () => model.dispatch('activity/query') : undefined,
        save: model ? (params) => model.dispatch('activity/save', params) : undefined
      },
      modalConfig: { width: "70%", height: "700", showFooter: true },
      // treeConfig: { children: 'Children' }
    }

    const formOptions: VxeFormProps = {
      titleWidth: 130,
      titleAlign: 'right',
      items: [
        // { field: "Photo.Uri",
        //   title: "封面圖片",
        //   span: 12, slots: { default: "column-photo-and-remark" }
        // },
        // { field: "Banner.Uri",
        //   title: "橫幅圖片",
        //   span: 12, slots: { default: "column-banner-and-remark" }
        // },
        {
          field: 'Name',
          title: '活動名稱',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
        },
        {
          field: 'Number',
          title: '編號',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '系統自動產生', clearable: true, disabled: 'true' }, attrs: { type: 'text' } }
        },
        // {
        //   field: 'PlanName',
        //   title: '計畫名稱',
        //   span: 12,
        //   itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
        // },
        {
          field: 'OwnerId',
          title: '承辦人',
          span: 12,
          slots: { default: "column-report-user-id" }
        },
        { field: "Type", title: "活動類型", span: 12, itemRender: { name: "$select", options: model ? Object.values(model.enums.ActivityType).map(e => { return { label: e.Name, value: e.Value } }) : [] } },
        // { field: "AreaType", title: "區域別", span: 12, itemRender: { name: "$select", options: model ? Object.values(model.enums.AreaType).map(e => { return { label: e.Name, value: e.Value } }) : [] } },       
        {
          field: 'StartTime',
          title: '開始時間',
          span: 12,
          // titleWidth: 100,
          itemRender: { name: '$input', props: { type: 'date', labelFormat: 'yyyy/MM/dd', placeholder: '請輸入日期', clearable: true } }
        }, {
          field: 'EndTime',
          title: '結束時間',
          span: 12,
          // titleWidth: 100,
          itemRender: { name: '$input', props: { type: 'date', labelFormat: 'yyyy/MM/dd', placeholder: '請輸入日期', clearable: true } }
        },
        {
          field: 'DueDate',
          title: '報名截止日期',
          span: 12,
          itemRender: { name: '$input', props: { type: 'date', labelFormat: 'yyyy/MM/dd', placeholder: '請輸入日期', clearable: true } }
        },
        // {
        //   field: 'Contact',
        //   title: '報名窗口',
        //   span: 12,
        //   itemRender: { name: '$textarea', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
        // },
        {
          field: 'Place',
          title: '活動地點',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
        },
        // {
        //   field: 'Map',
        //   title: '交通地圖',
        //   span: 24,
        //   itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
        // },
        // {
        //   field: 'Additional.Content',
        //   title: '補充說明',
        //   span: 24,
        //   itemRender: { name: '$textarea', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
        // },
        {
          field: 'Published',
          title: '已發布',
          span: 12,
          // titleWidth: 100,
          itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] }
        },
        {
          field: 'IsFree',
          title: '是否免費',
          span: 12,
          // titleWidth: 100,
          itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] }
        },
        // {
        //   field: 'HasForeign',
        //   title: '使用外籍欄位',
        //   span: 12,
        //   // titleWidth: 100,
        //   itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] }
        // },
        {
          field: 'RequireQnr',
          title: '是否必填問卷',
          span: 12,
          // titleWidth: 100,
          itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] }
        },
        {
          field: 'IsFull',
          title: '活動是否額滿',
          span: 12,
          // titleWidth: 100,
          itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] }
        },
        // {
        //   field: 'EpaperId',
        //   title: '電子報資料',
        //   span: 12,
        //   slots: { default: "column-epaper" }
        // },
        // {
        //   field: 'QnrId',
        //   title: '問卷資料',
        //   span: 12,
        //   slots: { default: "column-qnr" }
        // },
        // {
        //   field: 'AttendNoticedTime',
        //   title: '報到通知已發送時間',
        //   span: 12,
        //   // titleWidth: 100,
        //   itemRender: { name: '$input', props: { type: 'date', labelFormat: 'yyyy/MM/dd', placeholder: '請輸入日期', clearable: true } }
        // },
        // {
        //   field: 'DownloadNoticedTime',
        //   title: '簡報下載通知已發送時間',
        //   span: 12,
        //   // titleWidth: 100,
        //   itemRender: { name: '$input', props: { type: 'date', labelFormat: 'yyyy/MM/dd', placeholder: '請輸入日期', clearable: true } }
        // },
        {
          field: 'ViewCount',
          title: '檢視次數',
          span: 12,
          // titleWidth: 100,
          itemRender: { name: '$input', props: { type: 'number', placeholder: '請輸入數字', disabled: 'true' }, }
        },
        { span: 24, slots: { default: 'column-unit' } },
        { span: 24, slots: { default: 'html-editer' } },
        {
          span: 24,
          slots: { default: "files" }
        },
      ],
      rules: {
        Name: [{ type: 'string', required: true }],
        // PlanName: [{ type: 'string', required: true }],
        Type: [{ required: true }],
        IsFree: [{ required: true }],
        StartTime: [{ required: true }],
        EndTime: [{ required: true }],
        DueDate: [{ required: true }],
      }
    }

    const userSelectorOptions: SelectBoxOptions = {
      rowId: "Id",
      transfer: true,
      placeholder: "選擇",
      textField: "Name",
      valueField: "Id",
      columns: [
        {
          field: "Account",
          title: "帳號",
          width: "25%",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true
        },
        {
          field: "Name",
          title: "姓名",
          width: "25%",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true
        },
        {
          field: "Email",
          title: "Email",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true
        }
      ],
      showHeader: true,
      promises: {
        find: value => model!.dispatch("user/find", value), // eslint-disable-line
        query: params => {
          params.condition = new Condition("Status", Operator.Equal, 10).and(params.condition!);
          params.sortings!.push({ column: 'Name', order: 0 });
          return model!.dispatch("user/query", params) // eslint-disable-line
        }
      }
    };

    // function schemaCustomization(editor: any) {
    //   editor.model.schema.extend("$block", {
    //     allowAttributes: "classList"
    //   });
    //   editor.conversion.attributeToAttribute({
    //     model: {
    //       key: "classList"
    //     },
    //     view: {
    //       key: "class"
    //     }
    //   });
    // }

    const classicEditor = ClassicEditor;
    const contactConfig = {
      extraPlugins: [UploadAdapterPlugin],
      toolbar: {
        shouldNotGroupWhenFull: true,
        items: [
          "heading",
          "|",
          "fontFamily",
          "fontSize",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bold",
          "italic",
          "underline",
          "alignment",
          "bulletedList",
          "numberedList",
          "outdent",
          "indent",
          "highlight",
          "insertTable",
          "|",
          "link",
          "blockQuote",
          "imageInsert",
          "mediaEmbed",
          // 'codeBlock',
          "htmlEmbed",
          "|",
          "|",
          "undo",
          "redo",
          "sourceEditing"
        ]
      },
      removePlugins: ["Markdown"],
      image: {
        toolbar: [
          "imageTextAlternative",
          "imageStyle:full",
          "imageStyle:side",
          "linkImage"
        ]
      },
      table: {
        contentToolbar: [
          "tableColumn",
          "tableRow",
          "mergeTableCells",
          "tableCellProperties",
          "tableProperties"
        ]
      },
      heading: {
        options: [
          {
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          },
          {
            model: "heading1",
            view: { name: "h1", classes: "font-bold text-xl" },
            title: "Heading 1",
            class: "ck-heading_heading1"
          },
          {
            model: "heading2",
            view: { name: "h2", classes: "font-bold text-base" },
            title: "Heading 2",
            class: "ck-heading_heading2"
          }
        ]
      }
    };

    const editorConfig = {
      extraPlugins: [UploadAdapterPlugin],
      toolbar: {
        shouldNotGroupWhenFull: true,
        items: [
          "heading",
          "|",
          "fontFamily",
          "fontSize",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bold",
          "italic",
          "underline",
          "alignment",
          "bulletedList",
          "numberedList",
          "outdent",
          "indent",
          "highlight",
          "insertTable",
          "|",
          "link",
          "blockQuote",
          "imageInsert",
          "mediaEmbed",
          // 'codeBlock',
          "htmlEmbed",
          "|",
          "|",
          "undo",
          "redo",
          "sourceEditing"
        ]
      },
      removePlugins: ["Markdown"],
      image: {
        toolbar: [
          "imageTextAlternative",
          "imageStyle:full",
          "imageStyle:side",
          "linkImage"
        ]
      },
      table: {
        contentToolbar: [
          "tableColumn",
          "tableRow",
          "mergeTableCells",
          "tableCellProperties",
          "tableProperties"
        ]
      },
      heading: {
        options: [
          {
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          },
          {
            model: "heading1",
            view: { name: "h1", classes: "font-bold text-xl" },
            title: "Heading 1",
            class: "ck-heading_heading1"
          },
          {
            model: "heading2",
            view: { name: "h2", classes: "font-bold text-base" },
            title: "Heading 2",
            class: "ck-heading_heading2"
          }
        ]
      }
    };

    const selectorOptions: SelectBoxOptions = {
      rowId: "Id",
      transfer: true,
      placeholder: "",
      textField: "Title",
      valueField: "Id",
      addIfNotExists: false,
      columns: [
        { field: "Number", title: "編號", showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: "Title", title: "標題", showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: "Introduction", title: "說明", showHeaderOverflow: true, showOverflow: true, sortable: true },
      ],
      showHeader: true,
      promises: {
        find: (value) => model!.dispatch("qnr/find", value), // eslint-disable-line
        query: (params) => {
          params.condition = new Condition('Published', Operator.Equal, true)
          return model!.dispatch("qnr/query", params)
        }
      },
    };

    const epaperSelectorOptions: SelectBoxOptions = {
      rowId: "Id",
      transfer: true,
      placeholder: "",
      textField: "Subject",
      valueField: "Id",
      addIfNotExists: false,
      columns: [
        { field: "Subject", title: "電子報主旨", showHeaderOverflow: true, showOverflow: true, sortable: true },
      ],
      showHeader: true,
      promises: {
        find: (value) => model!.dispatch("epaper/find", value), // eslint-disable-line
        query: (params) => {
          params.condition = new Condition('Published', Operator.Equal, true).and('Type', Operator.Equal, 2);
          return model!.dispatch("epaper/query", params)
        }
      },
    };

    const sessionGrid = ref<any>()
    const sessionModal = reactive({
      visible: false,
      selectedRow: {} as any,
      gridOptions: {
        promises: {
          query: model ? (params) => {
            params.condition = new Condition()
              .and("ActivityId", Operator.Equal, sessionModal.selectedRow.Id.toString())
              .and(params.condition!);
            if (!params.sortings || params.sortings?.length === 0)
              params.sortings = [{ column: "Ordinal", order: 0 },{ column: "CreatedTime", order: 1 }];
            return model.dispatch("session/query", params);
          } : undefined,
          queryAll: model ? () => model.dispatch('session/query') : undefined,
          save: model ? (params) => model.dispatch('session/save', params) : undefined
        }
      } as GridOptions,
      show(row: any) {
        sessionModal.visible = true;
        sessionModal.selectedRow = row;
        if (sessionGrid.value) sessionGrid.value.refresh();
      }
    })

    const attendGrid = ref<any>()
    const attendModal = reactive({
      visible: false,
      selectedRow: {} as any,
      gridOptions: {
        promises: {
          query: model ? (params) => {
            params.condition = new Condition()
              .and("ActivityId", Operator.Equal, attendModal.selectedRow.Id.toString())
              .and(params.condition!);
            if (!params.sortings || params.sortings?.length === 0)
              params.sortings = [{ column: "CreatedTime", order: 1 }];
            var selectedStatus = attendGrid?.value.getSelectedStatus();
            if(selectedStatus != null) {
              params.condition .and("Status", Operator.Equal, selectedStatus)
            }
            return model.dispatch("attend/query", params);
          } : undefined,
          queryAll: model ? () => model.dispatch('attend/query') : undefined,
          save: model ? (params) => model.dispatch('attend/save', params) : undefined
        }
      } as GridOptions,
      show(row: any) {
        attendModal.visible = true;
        attendModal.selectedRow = row;
        if (attendGrid.value) attendGrid.value.refresh();
      }
    })

    // const surveyGrid = ref<any>()
    // const surveyModal = reactive({
    //   visible: false,
    //   selectedRow: {} as any,
    //   // gridOptions: {
    //   //   promises: {
    //   //     query: model ? (params) => {
    //   //       params.condition = new Condition()
    //   //         .and("ActivityId", Operator.Equal, surveyModal.selectedRow.Id.toString())
    //   //         .and(params.condition!);
    //   //       if (!params.sortings || params.sortings?.length === 0)
    //   //         params.sortings = [{ column: "CreatedTime", order: 1 }];
    //   //       var selectedStatus = surveyGrid?.value.getSelectedStatus();
    //   //       if(selectedStatus != null) {
    //   //         params.condition .and("Status", Operator.Equal, selectedStatus)
    //   //       }
    //   //       return model.dispatch("attend/query", params);
    //   //     } : undefined,
    //   //     queryAll: model ? () => model.dispatch('attend/query') : undefined,
    //   //     save: model ? (params) => model.dispatch('attend/save', params) : undefined
    //   //   }
    //   // } as GridOptions,
    //   show(row: any) {
    //     // surveyModal.visible = true;
    //     // surveyModal.selectedRow = row;
    //     // if (surveyGrid.value) surveyGrid.value.refresh();
    //   },
    //   close() {
    //     surveyModal.visible = false;
    //   }
    // })

    const fileGrid = ref<any>()
    const fileModal = reactive({
      visible: false,
      selectedRow: {} as any,
      uploadOptions: {
        promises: {
          async query() {
            var condition = new Condition("ActivityId", Operator.Equal, fileModal.selectedRow.Id);
            const sortings = [{ column: "CreatedTime", order: 1 }];
            return model?.dispatch('files/query', {
              condition: condition,
              sortings: sortings,
            });
          },
          insert(formData: FormData) {
            return model?.dispatch('files/insert', { formData, mode: 'other', entityId: 'Activity_' + fileModal.selectedRow.Id, fileType: 0 });
          },
          delete(id: number) {
            return model?.dispatch('files/delete', id);
          }
        }
      },
      show(row: any) {
        //fileModal.visible = true;
        fileModal.selectedRow = row;
        if (fileGrid.value) fileGrid.value.refresh();
      }
    })

    const unitTable = ref<any>();

    return {
      grid,
      model,
      selectorOptions,
      userSelectorOptions,
      gridOptions,
      formOptions,
      uploadAction: `${process.env.VUE_APP_BACKEND_URL}/api/files`,
      uploader,
      contactConfig,
      editorConfig,
      classicEditor,
      sessionGrid,
      sessionModal,
      attendGrid,
      attendModal,
      fileGrid,
      fileModal,
      epaperSelectorOptions,
      unitTable,
      // surveyGrid,
      // surveyModal,
    }
  },
  methods: {
    hideBatchDropDown () {
      cash('#batch-dropdown').dropdown('hide')
    },
    async uploaderFilter (current: VueUploadItem, original: VueUploadItem, prevent: any) {
      if (!current || !current.name) return prevent();
      if (!/\.(png|gif|jpg|jpeg)$/i.test(current.name)) {
        alert("未支援此種圖片格式");
        return prevent();
      }
    },
    async onGridEdit(row: any, callback: any) {
      const entity = row.Id
        ? await this.$model.dispatch("activity/find", row.Id)
        : undefined;
      if (entity) {
        if (entity.Keywords && entity.Keywords.length) {
          entity.KeywordIds = entity.Keywords.map((e: any) => e.KeywordId);
        } else {
          entity.KeywordIds = [];
        }
        Object.assign(row, entity);
        this.fileModal.show(row)
      }
      callback();
    },
    refresh() {
      (this.$refs.grid as any).refresh();
    },
  }
})
</script>
<style scope>
.ck.ck-balloon-panel {
  z-index: 2000;
}
</style>